<template>
  <b-form>
    <b-form-group>
      <validation-provider
        #default="{ errors }"
        name="puesto"
        rules="required"
      >
        <v-select
          v-if="!writePuesto.show"
          v-model="cargo.selected"
          :class="{ 'form-control is-invalid p-0' : (errors.length > 0 ? false:null) == false }"
          :options="puestos"
          placeholder="Catálogo de cargos"
          label="nombre"
          :clearable="false"
          filterable
        >
          <template #no-options>
            Sin resultados
          </template>
        </v-select>
        <b-form-input
          v-else
          v-model="cargo.alterno"
          :state="errors.length > 0 ? false:null"
          placeholder="Escribe tu cargo"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <b-badge
      :variant="writePuesto.hover ? 'primary' : 'light-secondary'"
      class="cursor-pointer"
      :class="{'badge-glow': writePuesto.hover}"
      @mouseover="writePuesto.hover = true"
      @mouseleave="writePuesto.hover = false"
      @click="changeInput()"
    >
      <feather-icon
        :icon="writePuesto.show ? 'MousePointerIcon' : 'Edit3Icon'"
        class="mr-25"
      />
      <span>
        {{ writePuesto.show ? 'Volver al catálogo de cargos' : 'Agregar al catálogo uno nuevo' }}
      </span>
    </b-badge>
  </b-form>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { required } from '@validations'
import {
  BForm, BFormGroup, BFormInput, BBadge,
} from 'bootstrap-vue'
import { getData } from '@core/utils/http/general'

export default {
  components: {
    BBadge,
    BForm,
    BFormGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      cargo: {
        alterno: null,
        selected: null,
      },
      puestos: [],
      writePuesto: {
        show: false,
        hover: false,
      },
      // VALIDATIONS
      required,
    }
  },
  created() { this.get_puestos() },

  methods: {
    changeInput() {
      if (!this.writePuesto.show) this.cargo.selected = { id: 2, nombre: 'Desconocido' }
      else this.cargo.alterno = null
      this.writePuesto.show = !this.writePuesto.show
    },
    get_puestos() {
      getData({ action: 10 })
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            this.puestos = response.data.data
          } else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Error cargando cargos`,
              variant: 'danger',
              solid: true,
            })
          }
        })
        .catch(err => {
          this.$bvToast.toast(err, {
            title: 'Error en solicitud [cargos]',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
}
</script>
